<div class="center" [attr.data-testid]="'landing-container'">
  <div class="flex items-center justify-center" [attr.data-testid]="'logo-container'">
    <gosu-icon theme="dark" [attr.data-testid]="'gosu-icon'"></gosu-icon>
    <gosu-logo theme="dark" [attr.data-testid]="'gosu-logo'"></gosu-logo>
  </div>
  <div class="text" i18n [attr.data-testid]="'landing-text'">點選左上漢堡選單，開始您專屬的故事之旅</div>
</div>
